import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../../../core/services/auth.service';
import { Beneficjent } from '../../../shared/models/beneficjent';

export const applicationContextResolver: ResolveFn<Beneficjent> = (
  route: ActivatedRouteSnapshot,
): Beneficjent => {
  const authService = inject(AuthService);
  return authService.getUser()!;
};
